// extracted by mini-css-extract-plugin
export default {"inputTextContainer":"style_inputTextContainer__0TqHy","inputText":"style_inputText__Vykgy","send":"style_send__aO-IX","error":"style_error__CYSbR"};